"use client";

import { useTranslations } from "next-intl";
import { cn } from "@/lib/utils";

type StatementStatus =
  | "draft"
  | "under_voting"
  | "approved"
  | "rejected"
  | "executed";

interface BlogStatusBadgeProps {
  status: StatementStatus | null | undefined;
  className?: string;
}

// Colored status pills for DAO statements/actions. draft → neutral grey;
// under_voting → blue (semantic-link — NOT `primary`, which is the
// near-black/near-white ink); approved («مصوب شده») → brand yellow (accent);
// executed («اجرا شده») → green (semantic-success); rejected → red. approved and
// executed are deliberately DIFFERENT colours per the design (a statement is
// first approved-yellow, then executed-green). Shape mirrors the neutral chips.
const STATUS_CLASS: Record<StatementStatus, string> = {
  draft: "bg-bg-tertiary text-text-secondary",
  under_voting: "bg-semantic-link/15 text-semantic-link",
  approved: "bg-accent/15 text-accent",
  rejected: "bg-semantic-error/15 text-semantic-error",
  executed: "bg-semantic-success/15 text-semantic-success",
};

export const BlogStatusBadge: React.FC<BlogStatusBadgeProps> = ({
  status,
  className,
}) => {
  const t = useTranslations("blog");
  if (!status) return null;
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-lg px-3 py-1.5 text-xs font-semibold",
        STATUS_CLASS[status],
        className,
      )}
    >
      {t(`status.${status}`)}
    </span>
  );
};
